module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-898896.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/glyphicons-halflings-regular.svg
 ** module id = 514
 ** module chunks = 2
 **/